import { data } from "../components/roleManagement/data";
import { constant } from "../constants";

export const getFeaturePermissions = (
  permissions: any,
  moduleName: string,
  featureName: string,
  submodule?: string
) => {
  if (!Array.isArray(permissions) || permissions.length === 0) {
    return {
      read: false,
      create: false,
      update: false,
      delete: false,
    };
  }

  let modulePermissions: any = permissions.find(
    (module: any) => module.name === moduleName
  );

  if (submodule) {
    modulePermissions = modulePermissions?.submodule?.find(
      (subModule: any) => subModule.name === submodule
    )?.permissions;

    return modulePermissions?.find(
      (feature: any) => feature.feature === featureName
    );
  }

  const featurePermissions = modulePermissions?.permissions?.find(
    (feature: any) => feature.feature === featureName
  );

  if (featurePermissions) {
    return featurePermissions;
  } else {
    return {
      read: false,
      create: false,
      update: false,
      delete: false,
    };
  }
};

export const getModulePermissions = (
  permissions: any,
  moduleName: any,
  submodule?: boolean
) => {
  let hasModuleAccess: any;

  if (!permissions || permissions?.length < 0) {
    return false;
  }
  // permissions = data;
  const modulePermissions = permissions?.find(
    (module: any) => module.name === moduleName
  );
  if (!modulePermissions || !modulePermissions.permissions) return false;
  if (submodule) {
    const mergeSubmodulePermissions: any[] = [];
    const subModulePermissions = modulePermissions.submodule
      .map((sub: any) => [...mergeSubmodulePermissions, ...sub.permissions])
      .flatMap((permissionArr: any) => permissionArr);
    hasModuleAccess = subModulePermissions?.filter(
      (feature: any) => feature.read === true
    );
    return hasModuleAccess.length > 0;
  }
  hasModuleAccess = modulePermissions?.permissions?.filter(
    (feature: any) => feature.read === true
  );
  return hasModuleAccess.length > 0;
};
